import { createRouter, createWebHistory } from "vue-router";
import { useAgreementStore } from "./stores/agreementStore";
import TopPage from "./views/TopPage.vue";
import Management from "./views/Management.vue";
import packageJson from "/package.json";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("./views/Map.vue")
  },
  {
    path: "/top",
    name: "TopPage",
    component: TopPage,
    meta: { isPublic: true }
  },
  {
    path: "/map",
    name: "Map",
    component: () => import("./views/Map.vue")
  },
  {
    path: "/management",
    name: "Management",
    component: Management,
    meta: { isPublic: true }
  },
  {
    path: "/management/Information",
    name: "ManagementInformation",
    component: () => import("./views/InformationManagement.vue"),
    meta: { isPublic: true }
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
});

router.beforeEach((to) => {
  const agreementStore = useAgreementStore();
  console.log(`... license  = ${agreementStore.isLicenseAgreed}`);

  if (
    to.matched.some(record => record.meta.isPublic) ||
    agreementStore.isLicenseAgreed
  ) {
    console.log(`router to:fullPath: ${to.fullPath}`);
    return true;
  } else {
    return {
      path: "/top",
      query: { redirect: to.fullPath, version: packageJson.version }
    };
  }
});

export default router;
